/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SpaceSlugRouteRouteImport } from './routes/$spaceSlug/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SpaceSlugIndexRouteImport } from './routes/$spaceSlug/index'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as DocumentsDocIdRouteImport } from './routes/documents/$docId'
import { Route as AuthRedirectRouteImport } from './routes/auth/redirect'
import { Route as SpaceSlugTagsRouteImport } from './routes/$spaceSlug/tags'
import { Route as SpaceSlugSettingsRouteImport } from './routes/$spaceSlug/settings'
import { Route as SpaceSlugNotesRouteImport } from './routes/$spaceSlug/notes'
import { Route as SpaceSlugLibraryRouteImport } from './routes/$spaceSlug/library'
import { Route as SpaceSlugChatRouteImport } from './routes/$spaceSlug/chat'
import { Route as SpaceSlugSplatRouteImport } from './routes/$spaceSlug/$'
import { Route as SpaceSlugDocumentsIndexRouteImport } from './routes/$spaceSlug/documents/index'
import { Route as SpaceSlugDocumentsDocIdRouteImport } from './routes/$spaceSlug/documents/$docId'

const SpaceSlugRouteRoute = SpaceSlugRouteRouteImport.update({
  id: '/$spaceSlug',
  path: '/$spaceSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpaceSlugIndexRoute = SpaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsDocIdRoute = DocumentsDocIdRouteImport.update({
  id: '/documents/$docId',
  path: '/documents/$docId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRedirectRoute = AuthRedirectRouteImport.update({
  id: '/auth/redirect',
  path: '/auth/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const SpaceSlugTagsRoute = SpaceSlugTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugSettingsRoute = SpaceSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugNotesRoute = SpaceSlugNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugLibraryRoute = SpaceSlugLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugChatRoute = SpaceSlugChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugSplatRoute = SpaceSlugSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugDocumentsIndexRoute = SpaceSlugDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)
const SpaceSlugDocumentsDocIdRoute = SpaceSlugDocumentsDocIdRouteImport.update({
  id: '/documents/$docId',
  path: '/documents/$docId',
  getParentRoute: () => SpaceSlugRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$spaceSlug': typeof SpaceSlugRouteRouteWithChildren
  '/$spaceSlug/$': typeof SpaceSlugSplatRoute
  '/$spaceSlug/chat': typeof SpaceSlugChatRoute
  '/$spaceSlug/library': typeof SpaceSlugLibraryRoute
  '/$spaceSlug/notes': typeof SpaceSlugNotesRoute
  '/$spaceSlug/settings': typeof SpaceSlugSettingsRoute
  '/$spaceSlug/tags': typeof SpaceSlugTagsRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/documents/$docId': typeof DocumentsDocIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$spaceSlug/': typeof SpaceSlugIndexRoute
  '/$spaceSlug/documents/$docId': typeof SpaceSlugDocumentsDocIdRoute
  '/$spaceSlug/documents/': typeof SpaceSlugDocumentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$spaceSlug/$': typeof SpaceSlugSplatRoute
  '/$spaceSlug/chat': typeof SpaceSlugChatRoute
  '/$spaceSlug/library': typeof SpaceSlugLibraryRoute
  '/$spaceSlug/notes': typeof SpaceSlugNotesRoute
  '/$spaceSlug/settings': typeof SpaceSlugSettingsRoute
  '/$spaceSlug/tags': typeof SpaceSlugTagsRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/documents/$docId': typeof DocumentsDocIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$spaceSlug': typeof SpaceSlugIndexRoute
  '/$spaceSlug/documents/$docId': typeof SpaceSlugDocumentsDocIdRoute
  '/$spaceSlug/documents': typeof SpaceSlugDocumentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$spaceSlug': typeof SpaceSlugRouteRouteWithChildren
  '/$spaceSlug/$': typeof SpaceSlugSplatRoute
  '/$spaceSlug/chat': typeof SpaceSlugChatRoute
  '/$spaceSlug/library': typeof SpaceSlugLibraryRoute
  '/$spaceSlug/notes': typeof SpaceSlugNotesRoute
  '/$spaceSlug/settings': typeof SpaceSlugSettingsRoute
  '/$spaceSlug/tags': typeof SpaceSlugTagsRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/documents/$docId': typeof DocumentsDocIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/$spaceSlug/': typeof SpaceSlugIndexRoute
  '/$spaceSlug/documents/$docId': typeof SpaceSlugDocumentsDocIdRoute
  '/$spaceSlug/documents/': typeof SpaceSlugDocumentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$spaceSlug'
    | '/$spaceSlug/$'
    | '/$spaceSlug/chat'
    | '/$spaceSlug/library'
    | '/$spaceSlug/notes'
    | '/$spaceSlug/settings'
    | '/$spaceSlug/tags'
    | '/auth/redirect'
    | '/documents/$docId'
    | '/invite/$token'
    | '/$spaceSlug/'
    | '/$spaceSlug/documents/$docId'
    | '/$spaceSlug/documents/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$spaceSlug/$'
    | '/$spaceSlug/chat'
    | '/$spaceSlug/library'
    | '/$spaceSlug/notes'
    | '/$spaceSlug/settings'
    | '/$spaceSlug/tags'
    | '/auth/redirect'
    | '/documents/$docId'
    | '/invite/$token'
    | '/$spaceSlug'
    | '/$spaceSlug/documents/$docId'
    | '/$spaceSlug/documents'
  id:
    | '__root__'
    | '/'
    | '/$spaceSlug'
    | '/$spaceSlug/$'
    | '/$spaceSlug/chat'
    | '/$spaceSlug/library'
    | '/$spaceSlug/notes'
    | '/$spaceSlug/settings'
    | '/$spaceSlug/tags'
    | '/auth/redirect'
    | '/documents/$docId'
    | '/invite/$token'
    | '/$spaceSlug/'
    | '/$spaceSlug/documents/$docId'
    | '/$spaceSlug/documents/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SpaceSlugRouteRoute: typeof SpaceSlugRouteRouteWithChildren
  AuthRedirectRoute: typeof AuthRedirectRoute
  DocumentsDocIdRoute: typeof DocumentsDocIdRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$spaceSlug': {
      id: '/$spaceSlug'
      path: '/$spaceSlug'
      fullPath: '/$spaceSlug'
      preLoaderRoute: typeof SpaceSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$spaceSlug/': {
      id: '/$spaceSlug/'
      path: '/'
      fullPath: '/$spaceSlug/'
      preLoaderRoute: typeof SpaceSlugIndexRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$docId': {
      id: '/documents/$docId'
      path: '/documents/$docId'
      fullPath: '/documents/$docId'
      preLoaderRoute: typeof DocumentsDocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/redirect': {
      id: '/auth/redirect'
      path: '/auth/redirect'
      fullPath: '/auth/redirect'
      preLoaderRoute: typeof AuthRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$spaceSlug/tags': {
      id: '/$spaceSlug/tags'
      path: '/tags'
      fullPath: '/$spaceSlug/tags'
      preLoaderRoute: typeof SpaceSlugTagsRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/settings': {
      id: '/$spaceSlug/settings'
      path: '/settings'
      fullPath: '/$spaceSlug/settings'
      preLoaderRoute: typeof SpaceSlugSettingsRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/notes': {
      id: '/$spaceSlug/notes'
      path: '/notes'
      fullPath: '/$spaceSlug/notes'
      preLoaderRoute: typeof SpaceSlugNotesRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/library': {
      id: '/$spaceSlug/library'
      path: '/library'
      fullPath: '/$spaceSlug/library'
      preLoaderRoute: typeof SpaceSlugLibraryRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/chat': {
      id: '/$spaceSlug/chat'
      path: '/chat'
      fullPath: '/$spaceSlug/chat'
      preLoaderRoute: typeof SpaceSlugChatRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/$': {
      id: '/$spaceSlug/$'
      path: '/$'
      fullPath: '/$spaceSlug/$'
      preLoaderRoute: typeof SpaceSlugSplatRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/documents/': {
      id: '/$spaceSlug/documents/'
      path: '/documents'
      fullPath: '/$spaceSlug/documents/'
      preLoaderRoute: typeof SpaceSlugDocumentsIndexRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
    '/$spaceSlug/documents/$docId': {
      id: '/$spaceSlug/documents/$docId'
      path: '/documents/$docId'
      fullPath: '/$spaceSlug/documents/$docId'
      preLoaderRoute: typeof SpaceSlugDocumentsDocIdRouteImport
      parentRoute: typeof SpaceSlugRouteRoute
    }
  }
}

interface SpaceSlugRouteRouteChildren {
  SpaceSlugSplatRoute: typeof SpaceSlugSplatRoute
  SpaceSlugChatRoute: typeof SpaceSlugChatRoute
  SpaceSlugLibraryRoute: typeof SpaceSlugLibraryRoute
  SpaceSlugNotesRoute: typeof SpaceSlugNotesRoute
  SpaceSlugSettingsRoute: typeof SpaceSlugSettingsRoute
  SpaceSlugTagsRoute: typeof SpaceSlugTagsRoute
  SpaceSlugIndexRoute: typeof SpaceSlugIndexRoute
  SpaceSlugDocumentsDocIdRoute: typeof SpaceSlugDocumentsDocIdRoute
  SpaceSlugDocumentsIndexRoute: typeof SpaceSlugDocumentsIndexRoute
}

const SpaceSlugRouteRouteChildren: SpaceSlugRouteRouteChildren = {
  SpaceSlugSplatRoute: SpaceSlugSplatRoute,
  SpaceSlugChatRoute: SpaceSlugChatRoute,
  SpaceSlugLibraryRoute: SpaceSlugLibraryRoute,
  SpaceSlugNotesRoute: SpaceSlugNotesRoute,
  SpaceSlugSettingsRoute: SpaceSlugSettingsRoute,
  SpaceSlugTagsRoute: SpaceSlugTagsRoute,
  SpaceSlugIndexRoute: SpaceSlugIndexRoute,
  SpaceSlugDocumentsDocIdRoute: SpaceSlugDocumentsDocIdRoute,
  SpaceSlugDocumentsIndexRoute: SpaceSlugDocumentsIndexRoute,
}

const SpaceSlugRouteRouteWithChildren = SpaceSlugRouteRoute._addFileChildren(
  SpaceSlugRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SpaceSlugRouteRoute: SpaceSlugRouteRouteWithChildren,
  AuthRedirectRoute: AuthRedirectRoute,
  DocumentsDocIdRoute: DocumentsDocIdRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
